/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import SearchIcon from "@mui/icons-material/Search";
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import Pagination from "../../components/common/new/Pagination/Pagination";
import Loader from "../../components/common/Loader/Loader";
import tableStyle from "../../theme/styles/table";
import style from "./University.styles";
import Table from "../../components/common/new/Table/Table";
import useUserConfig from "../../hooks/useUserConfig";
import IntroductionForm from "../../services/api/introductionForm";
import AddUniversityModal from "./CreateEditModal";
import University from "../../services/api/university";
import NewEdit from "../../assets/svg/NewEdit";
import Button from "../../components/common/Button";
import { AlertStatus } from "../../contants";
import { ToastAlertContext } from "../../config/providers/ToastAlert";

const DOWNLOAD_REPORTS_TABLE_COL = [
  {
    displayName: "S.No",
  },
  {
    displayName: "University Name",
  },
  {
    displayName: "Action",
  },
];

// const tabelCellWidth = {
//   tiny: {
//     maxWidth: "3.5rem",
//   },
//   small: {
//     maxWidth: "6rem",
//   },
//   medium: {
//     maxWidth: "10rem",
//   },
// };

const LOADER_DELAY = 1000;
// const DEFAULT_PAGE_SIZE = 5;

function UniversityList() {
  const [universityData, setUniversityData] = useState([]);
  // const [currentPage, setCurrentPage] = useState(0);
  // const [totalDownloadPages, setTotalPages] = useState(0);
  // const [totalDownloadElements, setTotalElements] = useState(0);
  // const [downloadSize, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const hasPermission = useUserConfig();
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalLabel, setModalLabel] = useState("Add University");
  const [updateData, setUpdateData] = useState({
    id: null,
    name: "",
  });
  const toast = useContext(ToastAlertContext);

  const laoding = useSelector((store) => store.view_friends.isLoading);
  // const openModalWithId = (id) => {
  //   setUpdateData({
  //     ...updateData,
  //     id,
  //   });
  //   setShowModal(true);
  //   setModalLabel("Edit University");
  // };
  const openModalWithId = (id) => {
    const universityToEdit = universityData.find(
      (university) => university.id === id
    );

    if (universityToEdit) {
      setUpdateData({
        id: universityToEdit.id,
        name: universityToEdit.name,
      });
      setShowModal(true);
      setModalLabel("Edit University");
    }
  };
  const handleAddUniversityClick = () => {
    setUpdateData({
      id: null,
      name: "",
    });
    setShowModal(true);
    setModalLabel("Add University");
  };

  async function fetchData() {
    try {
      setIsLoading(true);
      // const response = await Reports.downloadReports({
      //   pageNumber,
      //   pageSize,
      // });

      const response = await IntroductionForm.getUniversity();

      if (response.code === 200) {
        // const { content, totalPages, totalElements, size } = response.data;
        // setCurrentPage(pageNumber);
        // setSize(size);
        setTimeout(() => {
          // setTotalPages(totalPages);
          // setTotalElements(totalElements);
          setUniversityData(response.data);
          setIsLoading(false);
        }, LOADER_DELAY);
      } else {
        console.error("API Error:", response);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  }

  const handleFormSubmit = async () => {
    try {
      let response;

      if (updateData.id) {
        response = await University.updateUniversity({ data: updateData });
      } else {
        response = await University.createUniversity({ data: updateData });
      }

      if (response.code === 200) {
        if (response.code === 200) {
          toast.show("University updated successfully", AlertStatus.SUCCESS);
        }
        setShowModal(false);
      } else {
        toast.show("Failed to update university", AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
    fetchData();
  };

  // const onSearchClick = (pageNumber, pageSize) => {
  //   fetchData(pageNumber, pageSize);
  // };

  // const onPaginationClick = (page) => {
  //   onSearchClick(page, downloadSize);
  // };
  // const onRefresh = () => {
  //   fetchData(0, DEFAULT_PAGE_SIZE);
  // };

  // const onPageSizeClick = (operator) => {
  //   // const { pageSize } = paginationInfo;
  //   const newPageSize = performOperation(
  //     downloadSize,
  //     Constants.DEFAULT_PAGE_SIZE,
  //     operator
  //   );
  //   onSearchClick(0, newPageSize);
  // };
  const getRows = (data) =>
    data.map((universityInfo) => {
      return (
        <TableRow style={tableStyle.tableRow}>
          <TableCell>{universityInfo.id}</TableCell>
          <TableCell>{universityInfo.name || "-"}</TableCell>
          <TableCell>
            {" "}
            <Box sx={{ cursor: "pointer" }}>
              <NewEdit onClick={() => openModalWithId(universityInfo.id)} />
            </Box>
          </TableCell>
        </TableRow>
      );
    });

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box sx={style.container}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: "1rem",
        }}
      >
        <Box>
          <Button
            label="Add University"
            style={{ fontSize: "12px" }}
            onClick={handleAddUniversityClick}
          />
        </Box>
      </Box>
      {universityData?.length ? (
        <Box style={style.tableContainer}>
          <Box style={style.tableHeading}>
            <Box style={style.tableTitle}>University List</Box>
            <Box style={style.tableInfo}>
              Total University:{universityData.length + 1}
            </Box>
          </Box>
          <Box sx={{ maxHeight: "340px", overflowY: "scroll" }}>
            <Table
              scrollable
              columns={DOWNLOAD_REPORTS_TABLE_COL}
              rows={getRows(
                universityData,
                // currentPage,
                // downloadSize,
                hasPermission
              )}
              // hasAction
              hasPermission
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                textAlign: "center",
              }}
            />
          </Box>
          {/* <Box style={style.pagination}>
            <Pagination
              totalPages={totalDownloadPages}
              totalResults={totalDownloadElements}
              currentPage={currentPage}
              pageSize={downloadSize}
              onChange={onPaginationClick}
              onPageSizeClick={onPageSizeClick}
            />
          </Box> */}
        </Box>
      ) : (
        !universityData?.length &&
        laoding === false && (
          <Box style={style.emptyContainer}>
            <h1 style={style.noDataMsg}>No Results</h1>
          </Box>
        )
      )}
      {isLoading && <Loader />}

      <AddUniversityModal
        open={showModal}
        onClose={() => setShowModal(false)}
        updateData={updateData}
        setUpdateData={setUpdateData}
        onFormSubmit={handleFormSubmit}
        label={modalLabel}
      />
    </Box>
  );
}

export default UniversityList;
